<template>
  <div class="company_page">
    <div class="page_header">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>企业列表</el-breadcrumb-item>
			</el-breadcrumb>
			<el-button @click="additionCompany">添加企业</el-button>
		</div>
		<el-table :data="tableData" style="width: 100%">
			<el-table-column prop="sort">
				<template slot="header">
					<span>排序</span>
				</template>
				<template slot-scope="scope">
					<el-input v-model="scope.row.order" style="width: 80px;" @blur="setOrder(scope.row.company_id, scope.row.order)"></el-input>
				</template>
			</el-table-column>
			<el-table-column
				prop="company_name"
				label="企业名称">
			</el-table-column>
			<el-table-column
				prop="son_company_num"
				label="子公司数量">
			</el-table-column>
			<el-table-column
				prop="position_num"
				label="岗位数量">
			</el-table-column>
			<el-table-column
				prop=""
				label="创建时间">
			</el-table-column>
			<el-table-column
				width="210"
				label="操作">
				<template slot-scope="scope">
					<el-button type="text" size="mini" @click="handleEdit(scope.row.company_name, scope.row.company_detail, scope.row.company_logo, scope.row.company_id)">编辑信息</el-button>
					<el-button type="text" size="mini">
						<router-link :to="{ path: '/home/subcompany', query: { pid: scope.row.company_id, name:  scope.row.company_name} }">查看子公司</router-link>
					</el-button>
					<el-button type="text" size="mini" @click="handleOverFull(scope.row.company_id)">一键招满</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div class="page_container">
			<el-pagination
				background
				layout="prev, pager, next"
				@current-change="getPageList"
				:current-page.sync="page"
				:page-size="page_size"
				:total="total">
			</el-pagination>
		</div>
		<el-dialog title="添加企业" :visible.sync="dialogAdd" custom-class="self_dialog">
			<div class="dialog_inner">
				<el-form :model="addForm" :rules="rules" ref="addForm" label-width="100px" class="demo-ruleForm">
					<el-form-item label="企业名称" prop="company_name">
						<el-input v-model="addForm.company_name"></el-input>
					</el-form-item>
					<el-form-item label="企业简介" prop="company_detail">
						<el-input type="textarea" :rows=8 v-model="addForm.company_detail"></el-input>
					</el-form-item>
					<el-form-item label="企业logo" prop="company_logo">
						<el-upload
							class="avatar-uploader"
							:action="actionUrl"
							:headers="Token"
							:data="savePath"
							name="images"
							:show-file-list="false"
							:before-upload="beforeLogoUpload"
							:on-success="handleLogoSuccess">
							<img v-if="imageUrl" :src="imageUrl" class="avatar">
							<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						</el-upload>
						<p class="upload-tips">请上传正方形比例图片，图片大小不要超过5M！</p>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogAdd = false">取 消</el-button>
				<el-button type="primary" v-if="isAdd" @click="handleAddSubmit('addForm')">确认添加</el-button>
				<el-button type="primary" v-else @click="handleEditSubmit('addForm')">确认修改</el-button>
			</span>
		</el-dialog>
  </div>
</template>
<script>
	import { host } from '../utils/host.js';
	import { getLocalStorage } from '../utils/localStorage.js';
	export default {
		data() {
			return {
				tableData: [],
				dialogAdd: false,
				addForm: {
					company_name: '',
					company_detail: '',
					company_logo: '',
				},
				imageUrl: '',
				rules: {
					company_name: [
						{ required: true, message: '请输入企业名称', trigger: 'blur' }
					],
					company_detail: [
						{ required: true, message: '请输入企业简介', trigger: 'blur' }
					],
					company_logo: [
						{ required: true, message: '请上传企业logo' }
					]
				},
				page: 1,
				page_size: 10,
				total: 0,
				companyid: 0,
				isAdd: true,
				actionUrl: host +'/picture', //图片上传接收地址
				Token: { Token: getLocalStorage()},
				savePath: { type: 'HK' }
			}
		},
		created() {
			this.getCompanyList()
		},
		methods: {
			getCompanyList() { 
				this.$http.get('/hktopic/company', {
					params: {
						company_pid: 0,
						page: this.page,
						page_size: this.page_size
					}
				}).then(res => {
					if (res.data.code == 0) {
						this.tableData = res.data.data.data;
						this.total = res.data.data.total;
					}
				}).catch(err => {
					console.log(err)
				})
			},
			getPageList(page) {
				this.page = page;
				this.getCompanyList();
			},
			additionCompany() {
				this.addForm.company_name = '';
				this.addForm.company_detail = '';
				this.addForm.company_logo = '';
				this.imageUrl = '';
				this.dialogAdd = true;
				this.isAdd = true;
			},
			beforeLogoUpload(file) {
				const isLt5M = file.size / 1024 / 1024 < 5;
				if (!isLt5M) {
					this.$message.error('上传图片大小不能超过 5MB!');
				}
				return isLt5M;
			},
			handleLogoSuccess(res) {
				if (res.code == 0) {
					this.imageUrl = res.data.ossurl;
					this.addForm.company_logo = res.data.ossurl;
				}
			},
			handleEdit(name, detail, logo, id) {
				this.isAdd = false;
				this.dialogAdd = true;
				this.addForm.company_name = name;
				this.addForm.company_detail = detail;
				this.addForm.company_logo = logo;
				this.imageUrl = logo;
				this.companyid = id;
			},
			handleOverFull(id) {
				this.$confirm('确认将该企业下的全部职位设为招满状态?', '系统提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.get(`/hktopic/company/all_lower_shelf/${id}`).then(res => {
						if (res.data.code == 0) {
							this.$message.success('设置成功！');
							this.getCompanyList();
						}
					}).catch(err => {
						console.log(err)
					})
				}).catch(() => {
        
				});
			},
			handleAddSubmit(form) {
				this.$refs[form].validate((valid) => {
					if (valid) {
						this.$http.post('/hktopic/company', { ...this.addForm }).then(res => {
							if (res.data.code == 0) {
								this.$message.success('公司添加成功！');
								this.dialogAdd = false;
								this.getCompanyList();
							}
						}).catch(err => {
							console.log(err)
						})
					} else {
						return false;
					}
				});
				
			},
			handleEditSubmit(form) {
				this.$refs[form].validate((valid) => {
					if (valid) {
						this.$http.put(`/hktopic/company/${this.companyid}`, { ...this.addForm }).then(res => {
							if (res.data.code == 0) {
								this.$message.success('信息修改成功！');
								this.dialogAdd = false;
								this.getCompanyList();
							}
						}).catch(err => {
							console.log(err)
						})
					}else {
						return false
					}
				})
			},
			setOrder(id, order) {
				this.companyid = id;
				this.$http.put(`/hktopic/company/${this.companyid}`, { order: order }).then(res => {
					if (res.data.code == 0) {
						this.$message.success('排序修改成功！');
						this.dialogAdd = false;
						this.getCompanyList();
					}
				}).catch(err => {
					console.log(err)
				})
			}
		}
	}
</script>
<style lang="less">
	.company_page{
		.avatar-uploader .el-upload {
			border: 1px dashed #d9d9d9;
			border-radius: 6px;
			cursor: pointer;
			position: relative;
			overflow: hidden;
		}
		.avatar-uploader .el-upload:hover {
			border-color: #409EFF;
		}
		.avatar-uploader-icon {
			font-size: 28px;
			color: #8c939d;
			width: 120px;
			height: 120px;
			line-height: 120px;
			text-align: center;
		}
		.avatar {
			width: 120px;
			height: 120px;
			display: block;
		}
		.upload-tips{
			margin-top: 0;
			color: #4c7fff;
		}
	}
</style>
